import { useMutation } from '@tanstack/react-query';
import {
  PartnerRegisterPostError,
  PartnerRegisterPostParams,
  PartnerRegisterPostResponse,
} from '@/api/model/authentication/register.ts';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { BASE_URL_LANG } from '@/api/utils.ts';

const usePartnerRegisterPost = () =>
  useMutation<
    AxiosResponse<PartnerRegisterPostResponse>,
    AxiosError<PartnerRegisterPostError>,
    PartnerRegisterPostParams
  >({
    mutationFn: (params) => {
      const body = new FormData();
      Object.entries(params).forEach(([key, value]) => {
        body.append(key, String(value ?? ''));
      });

      return axios.post(`${BASE_URL_LANG}partners/registerPartner`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // Backend requires this header
          internal: 1,
        },
      });
    },
  });

export { usePartnerRegisterPost };
